import { Component, EventEmitter, Output, Input, ViewChild, ElementRef, OnInit } from '@angular/core';
import { PurchaseService } from '@ridango/components/lib/purchase/purchase.service';
@Component({
    selector: 'rwidget-product-quantity-selector',
    templateUrl: './product-quantity-selector.component.html'
})
export class ProductQuantitySelectorComponent implements OnInit {
    quantity = 1;
    @Input() locale = 'sv';
    @Input() step: number;
    @Output() amountChanged = new EventEmitter<number>();

    isEditing = false;
    inputValue = 0;
    maxQuantity!: number;
    @ViewChild('quantityInput') quantityInput: ElementRef<HTMLInputElement>;

    constructor(private purchaseService: PurchaseService) {}

    ngOnInit() {
        this.maxQuantity = this.purchaseService.MAX_TICKETS_AMOUNT;
    }

    amountChange(change: number) {
        if (this.quantity + change > this.maxQuantity) {
            this.quantity = this.maxQuantity;
        } else if (this.quantity + change < 1) {
            this.quantity = 1;
        } else {
            this.quantity = this.quantity + change;
        }
        this.amountChanged.emit(this.quantity);
    }

    onQuantityClick() {
        this.isEditing = true;
        this.inputValue = this.quantity;
    }

    onInputBlur() {
        this.applyInputValue();
    }

    onInputKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.applyInputValue();
            event.preventDefault();
        } else if (event.key === 'Escape') {
            this.isEditing = false;
            event.preventDefault();
        }
    }

    private applyInputValue() {
        if (this.inputValue > this.maxQuantity) {
            this.quantity = this.maxQuantity;
        } else if (this.inputValue < 1) {
            this.quantity = 1;
        } else {
            this.quantity = this.inputValue;
        }
        this.amountChanged.emit(this.quantity);
        this.isEditing = false;
    }
}
